<template>
        <div class="wrapper">
            <header id="primary">
                <nav id="top-navbar">
                    <div class="menu-icon">
                        <i class="fas fa-bars"></i>
                    </div>
                    <div class="logo">
                        <a href="/#/"><img src="../assets/Logo-Nikol.png" width="300" height="120"
                                                  alt="Logo"></a>
                    </div>
                    <div class="menu">
                        <ul>
                            <li><a class="text-upper" href="#omne">O MNĚ</a></li>
                            <li><a class="text-upper" href="#portfolio">PORTFOLIO</a></li>
                            <li><a class="text-upper" href="#cenik">CENÍK</a></li>
                            <li><a class="text-upper" href="#reference">REFERENCE</a></li>
                            <li><a class="text-upper" href="#kontakt">KONTAKT</a></li>
                        </ul>
                    </div>
                </nav>
                <video class="Nikol-video" autoplay loop muted>
                    <source src="../assets/Niki_bez_audia.mp4" type="video/mp4">
                </video>
            </header>
        </div>
</template>

<script>
    export default {
        name: "NavTop",
        components: {},
        data() {
            return {

            }

        },
        created() {
            window.addEventListener("scroll", function () {
                let scroll = this.scrollY;
                console.log(scroll);
                if (scroll > 100) {
                    document.getElementById('top-navbar').classList.add('black');
                }
                else {
                    document.getElementById('top-navbar').classList.remove('black');
                }
                if (scroll > 1270) {
                    document.getElementById('top-navbar').classList.add('hide');
                }
                else {
                    document.getElementById('top-navbar').classList.remove('hide');
                }

        });
        }
    }

</script>

<style scoped>
    .hide {
        display: none;
    }
    a:hover {
        color: blue;
    }
    .logo {
        line-height: 60px;
        position: fixed;
        float: left;
        margin: 16px 46px;
        color: #fff;
        font-weight: bold;
        font-size: 20px;
        letter-spacing: 2px;
    }

    nav {
        position: fixed;
        width: 100%;
        line-height: 60px;
        z-index: 1;
    }

    nav ul {
        line-height: 60px;
        list-style: none;
        background: #ffffff00;
        overflow: hidden;
        color: #fff;
        padding: 0;
        text-align: right;
        margin: 0;
        padding-right: 40px;
        transition: 1s;
    }

    nav.black ul {
        background: #000;
    }

    nav ul li {
        display: inline-block;
        padding: 40px 40px;
        font-weight: 900;
    }

    nav ul li a {
        text-decoration: none;
        color: #fff;
        font-size: 16px;
    }

    .menu-icon {
        line-height: 60px;
        width: 100%;
        background: #000;
        text-align: right;
        box-sizing: border-box;
        padding: 15px 24px;
        cursor: pointer;
        color: #fff;
        display: none;
    }
    .fas {
        font-weight: 900;
        font-size: 50px;
        vertical-align: middle;
    }
    @media(max-width: 976px) {

        .logo {
            display: none;
            position: fixed;
            top: 0;
            margin-top: 16px;
        }

        nav ul {
            max-height: 0px;
            background: #000;
        }

        nav.black ul {
            background: #000;
        }

        .showing {
            max-height: 50em;
        }

        nav ul li {
            box-sizing: border-box;
            width: 100%;
            padding: 4px;
            text-align: center;
        }

        .menu-icon {
            display: block;
        }

    }
    header {
        margin-bottom: -0.8em;
    }
    header a:hover {
        text-decoration: none;
    }
    /*===============-------VIDEO------==============*/
    header, #primary {
        background: url(../assets/Gack-uvod-Nikol.jpg) no-repeat;
        background-size: cover;
        background-position: center;
        height: 100vh;
    }
    @media screen and (max-width: 700px) {
        #primary {
            display: none;
        }
    }
    .Nikol-video {
        height: auto;
        width: 100%;
    }
    /*===============-------RESPONZIV------==============*/
    @media(max-width: 976px) {
        .Nikol-video {
            display: none;
        }
    }
    @media(min-width: 976px) {
        header, #primary {
            background: none;
            height: auto;
        }
    }
    @media screen and (max-width: 976px){
        #top-navbar {
            display: none;
        }
    }

</style>